import React, { useEffect, useState } from "react";
//import Herowithvideo from "../components/Generic/Herowithvideo";
import VisionMission from "../components/Aboutus/VisionMission";
//import Team from "../components/Aboutus/Team";
import Seo from "../components/Generic/Seo";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";
import { getByQuery } from "../api/API";
import InViewFade from "../components/Generic/InViewFade";
import LoadingSpinner from "../components/Generic/LoadingSpinner";
import C2c2c from "../components/Home/C2C2C";
import SplitHero from "../components/Generic/SplitHero";

const AboutPage = () => {
  const [aboutVideo, setAboutVideo] = useState(null);
  const [loading, setLoading] = useState(true);

  const seoData = {
    title:
      "About Wise Community | Our Vision, Mission & TeamAbout WiSE — Women in Semiconductor Ecosystem | Our Story & Mission",
    description:
      "Discover WiSE (Women in Semiconductor Ecosystem): our mission, vision and story. We empower, connect and elevate women from campus to corporate to career in the semiconductor industry through mentorship, community and opportunity.",
    keywords:
      "Women in Semiconductor, WiSE, about WiSE, semiconductor women community, women in tech semiconductors, semiconductor mentorship, women leadership semiconductor, women in STEM semiconductor, diversity in semiconductor, women empowerment semiconductor, semiconductor industry women, WiSE mission",
    pathSlug: "about",
  };

  const aboutTextData = {
    title: "How it started",
    subtitle:
      "WiSE was born from a simple but urgent realization: despite the rapid growth and global importance of the semiconductor industry, women continue to be significantly underrepresented across technical, leadership, and decision-making roles. Many talented women struggle with limited access to mentors and visible role models, fewer meaningful networking opportunities, and a lack of safe, inclusive spaces to learn, share experiences, and grow with confidence. WiSE began to bridge these gaps by creating a community-driven platform that supports women at every stage of their journey, from students to seasoned professionals, so that diversity, innovation, and leadership can truly thrive in the semiconductor ecosystem.",
  };

  useEffect(() => {
    async function fetchAboutVideo() {
      try {
        const query = `where[folder.slug]=abouthero&where[mimeType][like]=video/&sort=-createdAt&limit=1`;
        const res = await getByQuery("/media", query);
        if (res?.docs?.length > 0) {
          const video = res.docs[0];
          setAboutVideo({
            videoSrc: video.url || "",
            videoPoster: video.thumbnail?.url || "",
          });
        }
      } catch (error) {
        console.error("Error fetching about video", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAboutVideo();
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center my-5"
        style={{ minHeight: "400px" }}
      >
        <LoadingSpinner text="Loading About..." />
      </div>
    );
  }

  return (
    <>
      <Seo data={seoData} />
      <GoogleAnalytics page={seoData.pathSlug} title={seoData.title} />

      <InViewFade direction="up">
  <SplitHero
    title="HOW IT STARTED"
    description={aboutTextData.subtitle}
    imageSrc="/assets/images/Events.png"
    imagePosition="left"
  />
</InViewFade>


      {/* <InViewFade direction="right">
        <Team />
      </InViewFade> */}

      <InViewFade direction="left">
        <VisionMission />
      </InViewFade>

      <InViewFade direction="right">
        <C2c2c />
      </InViewFade>
    </>
  );
};

export default AboutPage;
